import { CourseMarkdown } from "@/components/storyboard/CourseMarkdown";

interface Props {
  text: string;
}

export const TextProvocativeQuestion = ({ text }: Props) => {
  return (
    <div className="rounded-2xl overflow-hidden mb-1.5">
      <div className="pr-6 pt-6 pb-3">
        <span className="prose prose-p:inline max-w-full text-h3 font-bold">
          <CourseMarkdown>{text}</CourseMarkdown>
        </span>
      </div>
    </div>
  );
};
